import { Component, computed, inject, ChangeDetectionStrategy } from "@angular/core";
import { PillboxComponent } from "~app/common/components/pillbox/pillbox.component";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";

@Component({
    selector: "rask-welcome-section",
    templateUrl: "./welcome-section.component.html",
    styleUrl: "./welcome-section.component.scss",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PillboxComponent]
})
export class WelcomeSectionComponent {
    protected greeting = computed(() => {
        const hour = new Date().getHours();

        if (hour >= 5 && hour < 9) {
            return "God morgon";
        } else if (hour >= 9 && hour < 12) {
            return "God förmiddag";
        } else if (hour >= 12 && hour < 17) {
            return "God eftermiddag";
        } else {
            return "God kväll";
        }
    });

    protected greetingIcon = computed(() => {
        const hour = new Date().getHours();

        if (hour >= 5 && hour < 9) {
            return "fa-cloud-sun";
        } else if (hour >= 9 && hour < 12) {
            return "fa-sun";
        } else if (hour >= 12 && hour < 17) {
            return "fa-sun-bright";
        } else if (hour >= 17 && hour < 22) {
            return "fa-cloud-sun";
        } else {
            return "fa-moon";
        }
    });

    protected firstName = computed(() => {
        const user = this.authService.getUserData();
        return user?.fullUserName?.split(" ")[0] || "";
    });

    protected kompassenUrl =
        "https://sveaskog.sharepoint.com/sites/Kompassen/Sidor/Start.aspx";

    private readonly authService = inject(AuthenticationService);

    protected openKompassen(): void {
        window.open(this.kompassenUrl, "_blank");
    }
}
